import e from"react";const t=({className:t,children:a})=>e.createElement("tfoot",{className:t},a);export{t as TableFooter};
//# sourceMappingURL=TableFooter.js.map
